(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["claude-category-tiles"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (!root || root.dataset.cctReady) return;
      root.dataset.cctReady = '1';
      var track = root.querySelector('[data-cct-track]');
      var prev = root.querySelector('[data-cct-prev]');
      var next = root.querySelector('[data-cct-next]');
      var dots = root.querySelector('[data-cct-dots]');
      if (!track) return;

      function pages() { return Math.max(1, Math.ceil((track.scrollWidth - 2) / track.clientWidth)); }

      function buildDots() {
        if (!dots) return;
        var n = pages();
        dots.innerHTML = '';
        if (n < 2) return;
        for (var i = 0; i < n; i++) {
          var d = document.createElement('span');
          d.className = 'cct__dot';
          dots.appendChild(d);
        }
      }

      function update() {
        var max = track.scrollWidth - track.clientWidth;
        var x = track.scrollLeft;
        if (prev) prev.hidden = x <= 4 || max <= 4;
        if (next) next.hidden = x >= max - 4 || max <= 4;
        if (dots && dots.children.length) {
          var n = dots.children.length;
          var idx = max > 0 ? Math.round((x / max) * (n - 1)) : 0;
          for (var i = 0; i < n; i++) dots.children[i].classList.toggle('is-active', i === idx);
        }
      }

      function step(dir) {
        track.scrollBy({ left: dir * track.clientWidth * 0.85, behavior: 'smooth' });
      }

      if (prev) prev.addEventListener('click', function () { step(-1); });
      if (next) next.addEventListener('click', function () { step(1); });
      root.querySelectorAll('[data-cct-gift]').forEach(function (gift) {
        gift.addEventListener('click', function (e) {
          if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
          var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          e.preventDefault();
          if (gift.classList.contains('is-open')) return;
          gift.classList.add('is-open');
          window.setTimeout(function () { window.location.href = gift.href; }, reduce ? 700 : 1150);
        });
        window.addEventListener('pageshow', function () { gift.classList.remove('is-open'); });
      });
      track.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
      window.addEventListener('resize', function () { buildDots(); update(); });
      buildDots();
      update();
    }

    function initAll() { document.querySelectorAll('[data-cct]').forEach(init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
    else initAll();
    document.addEventListener('shopify:section:load', function (e) { init(e.target && e.target.querySelector('[data-cct]')); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
